/**
 * Gemeinsamer Gate: Soll der Projektname für den aktuellen Nutzer verschleiert
 * werden? Datennutzer und nicht angemeldete (rein lesende) Betrachter dürfen
 * Projektnamen nicht sehen (Datenschutz 2026-06-13). Spiegelt
 * `shouldMaskSensitiveData` (Datennutzer ODER nicht angemeldet).
 *
 * Wird sowohl vom Transient-Banner („Projekt … vorübergehend geöffnet") als
 * auch vom Frozen-Banner („gehört zum Projekt …") genutzt, damit beide
 * dieselbe Regel teilen. Rein (kein Angular-DI) für einfache Testbarkeit.
 */
export function shouldHideProjectName(isAuthenticated: boolean, isDatennutzer: boolean): boolean {
	return !isAuthenticated || isDatennutzer;
}
